import { render, staticRenderFns } from "./CashierRobuxElement.vue?vue&type=template&id=6c1cb1ab&scoped=true"
import script from "./CashierRobuxElement.vue?vue&type=script&lang=js"
export * from "./CashierRobuxElement.vue?vue&type=script&lang=js"
import style0 from "./CashierRobuxElement.vue?vue&type=style&index=0&id=6c1cb1ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1cb1ab",
  null
  
)

export default component.exports